const offices = [
    {
        officeName: "Barnet",
        officeCode: ["BAR", "BRL"],
        salesRookEmail: "robot+martyngerrarden5@salesrook.com",
    },
    {
        officeName: "Crouch End",
        officeCode: ["CRE", "CRL"],
        salesRookEmail: "robot+martyngerrardn8@salesrook.com",
    },
    {
        officeName: "East Finchley",
        officeCode: ["EAF", "EAL"],
        salesRookEmail: "robot+martyngerrardn2@salesrook.com",
    },
    {
        officeName: "Finchley Central",
        officeCode: ["FIN", "FIL"],
        salesRookEmail: "robot+martyngerrardn3@salesrook.com",
    },
    {
        officeName: "Hampstead",
        officeCode: ["HAM", "HAL"],
        salesRookEmail: "robot+martyngerrardnw3@salesrook.com",
    },
    {
        officeName: "Islington",
        officeCode: ["ISS", "ISL"],
        salesRookEmail: "robot+martyngerrardn1@salesrook.com",
    },
    {
        officeName: "Kentish Town",
        officeCode: ["KNT", "KNL"],
        salesRookEmail: "robot+martyngerrardnw5@salesrook.com",
    },
    {
        officeName: "Land and New Homes",
        officeCode: ["NEW"],
        salesRookEmail: "robot+martyngerrardnewhomes@salesrook.com",
    },
    {
        officeName: "Mill Hill",
        officeCode: ["MHL", "MIL"],
        salesRookEmail: "robot+martyngerrardnw7@salesrook.com",
    },
    {
        officeName: "Muswell Hill",
        officeCode: ["MUL", "MWL"],
        salesRookEmail: "robot+martyngerrardn10@salesrook.com",
    },
    {
        officeName: "North Finchley",
        officeCode: ["NFI", "NFL"],
        salesRookEmail: "robot+martyngerrardn12@salesrook.com",
    },
    {
        officeName: "Whetstone",
        officeCode: ["WHT", "WHL"],
        salesRookEmail: "robot+martyngerrardn20@salesrook.com",
    },
    {
        officeName: "Winchmore Hill",
        officeCode: ["WMH", "WHI"],
        salesRookEmail: "robot+martyngerrardn21@salesrook.com",
    },
];


export const OfficeEmailMatch = (Office_crm_id) => {
    const DEFAULT_EMAIL = "HO@martyngerrard.co.uk";

    if (typeof Office_crm_id !== "string" || !Office_crm_id.trim()) {
        return DEFAULT_EMAIL;
    }

    const normalizedId = Office_crm_id.trim().toUpperCase();

    const matchedOffice = offices.find(office =>
        Array.isArray(office.officeCode) &&
        office.officeCode.some(code => code.toUpperCase() === normalizedId)
    );

    return matchedOffice?.salesRookEmail ?? DEFAULT_EMAIL;
};